import { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import Casebanner from "../components/Casebanner/Casebanner";
import Articlebanner from "../components/Articlebanner/Articlebanner";
import Author from "../components/Author/Author";

function formatDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${d.getFullYear()}`;
}

export default function PreviewPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [contentType, setContentType] = useState(null);
  const backend = process.env.REACT_APP_BACKEND_LINK;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const ct = params.get("content_type");

    if (!token || !ct) {
      setError("Missing token or content_type in URL.");
      return;
    }

    setContentType(ct);

    const url = new URL(backend + "api/v2/case_preview/");
    url.searchParams.set("content_type", ct);
    url.searchParams.set("token", token);
    url.searchParams.set("fields", "*");

    fetch(url.toString())
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then(setData)
      .catch((err) => setError(err.message));
  }, [backend]);

  if (error)
    return (
      <Layout>
        <p style={{ padding: "2rem" }}>Preview error: {error}</p>
      </Layout>
    );

  if (!data)
    return (
      <Layout>
        <p style={{ padding: "2rem" }}>Loading preview...</p>
      </Layout>
    );

  const isArticle = contentType?.includes("Article");
  const coverImage = data.cover ? data.cover.meta.download_url : "";
  const bodyHtml = data.body
    ? data.body.replace(/src="(\/[^"]+)"/g, `src="${backend.replace(/\/$/, "")}$1"`)
    : null;

  if (isArticle) {
    const publishedDate = formatDate(data.meta?.first_published_at);
    const editedDate = formatDate(data.meta?.last_published_at);

    return (
      <Layout>
        <Articlebanner image={coverImage} />

        <section id="article-meta">
          <div className="article-meta-inner">
            <div className="article-title-block">
              <h1 className="article-title-text">{data.title}</h1>
              {data.intro && (
                <p className="article-intro-text">{data.intro}</p>
              )}
            </div>
            {(publishedDate || editedDate) && (
              <div className="article-dates">
                {publishedDate && (
                  <p className="article-date-line">
                    <strong>Published:</strong> {publishedDate}
                  </p>
                )}
                {editedDate && editedDate !== publishedDate && (
                  <p className="article-date-line">
                    <strong>Edited:</strong> {editedDate}
                  </p>
                )}
              </div>
            )}
          </div>
        </section>

        <section id="article-body">
          {bodyHtml ? (
            <div
              className="article-body-container"
              dangerouslySetInnerHTML={{ __html: bodyHtml }}
            />
          ) : (
            <div className="no-data">
              <p className="body-large" style={{ fontWeight: "bold" }}>
                No Data Found
              </p>
            </div>
          )}
        </section>

        {data.author?.id && <Author author_id={data.author.id} />}
      </Layout>
    );
  }

  return (
    <Layout>
      <Casebanner
        image={coverImage}
        heading={data.title}
        intro={data.intro}
        role={data.group}
        tools={data.tools}
      />
      <section id="case-body">
        {bodyHtml ? (
          <div
            className="case-body-container"
            dangerouslySetInnerHTML={{ __html: bodyHtml }}
          />
        ) : (
          <div className="no-data">
            <p className="body-large" style={{ fontWeight: "bold" }}>
              No Data Found
            </p>
          </div>
        )}
      </section>
      {data.author?.id && <Author author_id={data.author.id} />}
    </Layout>
  );
}
